import { forwardRef } from 'react'
import PropTypes from 'prop-types'

// material-ui
import { useTheme } from '@mui/material/styles'
import { Avatar, ButtonBase, Tooltip } from '@mui/material'

// ==============================|| AVATAR BUTTON ||============================== //

const AvatarButton = forwardRef((props, _) => {
  const { background, callbacks, children, color, disabled, downloadUrl, tooltip = '', tooltipPlacement = 'top', transparent, size } = props

  const { toggleClick } = callbacks || {}

  const theme = useTheme()

  return (
    <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
      <Tooltip title={tooltip} placement={tooltipPlacement} arrow disableHoverListener={!tooltip}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            background: disabled || transparent ? 'transparent' : background || theme.palette.primary.light,
            color: disabled ? theme.palette.primary[200] : color || theme.palette.primary.dark,
            ...(size && { width: size, height: size }),
            '&:hover': {
              background: disabled || transparent ? theme.palette.grey[50] : color || theme.palette.primary.dark,
              color: disabled ? theme.palette.primary[200] : background || theme.palette.primary.light,
            },
          }}
          onClick={(e) => disabled ? null : (downloadUrl || downloadUrl === '' ? null : toggleClick(e))}
          color="inherit"
          as={downloadUrl ? 'a' : 'div'}
          href={downloadUrl}
          target="_blank"
        >
          {children}
        </Avatar>
      </Tooltip>
    </ButtonBase>
  )
})
AvatarButton.propTypes = {
  background: PropTypes.string,
  callbacks: PropTypes.object,
  children: PropTypes.node,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  transparent: PropTypes.bool,
  downloadUrl: PropTypes.string,
  size: PropTypes.number,
}

export default AvatarButton
